import React from 'react';
import { loginWithGoogle } from '../services/api';
import '../styles/Login.css';

function Login() {
  return (
    <div className="login-container">
      <div className="login-box">
        <h1>TaskFlow</h1>
        <p className="subtitle">ניהול קריאות שירות</p>
        
        <button 
          className="google-login-btn"
          onClick={loginWithGoogle}
        >
          <img 
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" 
            alt="Google" 
          />
          התחבר עם Google
        </button>
      </div>
    </div>
  );
}

export default Login;